import { JSX } from 'react';

interface IProps {
	children: JSX.Element | JSX.Element[];
	className?: string;
}

export default function Container({ children, className }: IProps) {
	return (
		<div className={`w-full h-full flex justify-center py-6 sm:py-12 px-8 xl:px-0 ${className}`}>
			<div className={'w-full max-w-screen-xl'}>
				{children}
			</div>
		</div>
	);
}